import { Component, OnInit, HostListener, ViewChild, ElementRef, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-cymi',
  templateUrl: './cymi.component.html',
  styleUrls: ['./cymi.component.scss']
})
export class CymiComponent implements OnInit {

  public fixed:boolean;
  public scroll:boolean;
  public itsMobile = false;

  constructor(private el: ElementRef, @Inject(DOCUMENT) private document: any) { }

  ngOnInit(): void {
    if (this.verifyMobile()) {
      this.itsMobile = true;
    }

    // if(this.itsMobile == true){
    //   const main = this.el.nativeElement.querySelector('.main-section');
    //   const scrollHelper = this.el.nativeElement.querySelector('.scroll-helper');
    //   setTimeout(function(){
    //     main.style.display = "block";
    //     scrollHelper.style.opacity = ".7";
    //   }, 18000)

    // }

   // this.document.documentElement.classList.add('block-scroll');

  }
  ngOnDestroy(): void {
    // this.document.documentElement.classList.remove('block-scroll');
  }

  // @ViewChild("cymi") cymi: ElementRef;

  // @HostListener('body:scroll', ['$event'])
  // onScrollingEvent($event): void {
  //   let scrollOffset = $event.target.scrollTop;

  //   // const section1 = this.cymi.nativeElement.offsetTop;

  //   if(scrollOffset >= section1 - 80){
  //     this.fixed = true;
  //   }else{
  //     this.fixed = false;
  //   }
  // }



  // @HostListener('body:scroll', ['$event'])
  // onScrollingEvent($event): void {

    // let scrollOffset = $event.target.scrollTop;



    // const section1 = this.cymi.nativeElement.offsetTop;
    // console.log(section1)
    // const iframe = this.el.nativeElement.querySelector('.section-iframe');
    // const main = this.el.nativeElement.querySelector('.main-section');

    // if(this.itsMobile == false){
    //   iframe.style.transform = "translateY(" + scrollOffset + "px)";

    //   if(scrollOffset >= 240){
    //     main.style.display = "block";
    //     iframe.style.transform = "none";
    //   }else if(scrollOffset == 0){
    //     iframe.style.transform = "translateY(" + scrollOffset + "px)";
    //     main.style.display = "none";
    //   }
    // }



    // if(scrollOffset >= section1 - 80){
    //   this.fixed = true;
    // }else{
    //   this.fixed = false;
    // }

  // }

  verifyMobile(): any {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

}
